/**
 * Transforms a date string or Date object to a Date object while preserving the exact date and time
 * without timezone conversion.
 *
 * @param dateInput - Date string in format "2025-07-16T00:00:00.000Z" or "2025-07-16" or Date object
 * @returns Date object with the same date and time, avoiding local timezone conversion
 */
export function transformDate(dateInput: string | Date): Date {
	// If input is already a Date object, return it as is
	if (dateInput instanceof Date) {
		return dateInput;
	}

	// Handle string input
	const dateString = dateInput;

	// Extract the original components from the ISO string to avoid timezone conversion
	const year = Number.parseInt(dateString.slice(0, 4), 10);
	const month = Number.parseInt(dateString.slice(5, 7), 10) - 1; // Month is 0-indexed
	const day = Number.parseInt(dateString.slice(8, 10), 10);

	// Extract time components if they exist, otherwise default to 0
	const hour =
		dateString.length > 10 ? Number.parseInt(dateString.slice(11, 13), 10) : 0;
	const minute =
		dateString.length > 13 ? Number.parseInt(dateString.slice(14, 16), 10) : 0;
	const second =
		dateString.length > 16 ? Number.parseInt(dateString.slice(17, 19), 10) : 0;
	const millisecond =
		dateString.length > 20 ? Number.parseInt(dateString.slice(20, 23), 10) : 0;

	// Create a new Date object with the exact components, treating them as local time
	return new Date(year, month, day, hour, minute, second, millisecond);
}
